// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1Zd3y","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3mAvf"};